import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { authService } from '@/services/auth';

export default function PublicNavbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const isLoggedIn = authService.isAuthenticated();
  const user = authService.getUser();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <img src="/icon-32.png" alt="VideoQR" className="w-7 h-7 rounded-md" />
            <span className="text-xl font-bold text-accent">VideoQR</span>
          </Link>

          {/* Desktop Links */}
          <div className="hidden md:flex items-center gap-6">
            <Link to="/discover" className="text-text-secondary hover:text-white transition-colors">
              Discover
            </Link>
            {isLoggedIn && (
              <>
                <Link to="/studio" className="text-text-secondary hover:text-white transition-colors">
                  Studio
                </Link>
                <Link to="/upload" className="text-text-secondary hover:text-white transition-colors">
                  Upload
                </Link>
              </>
            )}
            <Link to="/getting-started" className="text-text-secondary hover:text-white transition-colors">
              How To
            </Link>
            <Link to="/pricing" className="text-text-secondary hover:text-white transition-colors">
              Pricing
            </Link>
          </div>

          {/* Desktop Auth */}
          <div className="hidden md:flex items-center gap-3">
            {isLoggedIn ? (
              <Link
                to="/studio"
                className="px-4 py-2 bg-accent hover:bg-accent-dark text-white rounded-lg transition-colors flex items-center gap-2"
              >
                <span className="w-6 h-6 rounded-full bg-accent-light/30 flex items-center justify-center text-xs font-bold">
                  {(user?.displayName || user?.email || 'U')[0].toUpperCase()}
                </span>
                {user?.displayName || 'My Studio'}
              </Link>
            ) : (
              <>
                <Link
                  to="/login"
                  className="px-4 py-2 text-text-secondary hover:text-white transition-colors"
                >
                  Login
                </Link>
                <Link
                  to="/signup"
                  className="px-4 py-2 bg-accent hover:bg-accent-dark text-white rounded-lg transition-colors"
                >
                  Sign Up
                </Link>
              </>
            )}
          </div>

          {/* Mobile Hamburger */}
          <button
            className="md:hidden p-2 text-text-secondary hover:text-white"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? (
              <XMarkIcon className="w-6 h-6" />
            ) : (
              <Bars3Icon className="w-6 h-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-midnight-surface border-t border-midnight-border">
          <div className="px-4 py-4 space-y-3">
            <Link
              to="/discover"
              className="block text-text-secondary hover:text-white transition-colors"
              onClick={() => setMobileOpen(false)}
            >
              Discover
            </Link>
            {isLoggedIn && (
              <>
                <Link
                  to="/studio"
                  className="block text-text-secondary hover:text-white transition-colors"
                  onClick={() => setMobileOpen(false)}
                >
                  Studio
                </Link>
                <Link
                  to="/upload"
                  className="block text-text-secondary hover:text-white transition-colors"
                  onClick={() => setMobileOpen(false)}
                >
                  Upload
                </Link>
                <Link
                  to="/settings"
                  className="block text-text-secondary hover:text-white transition-colors"
                  onClick={() => setMobileOpen(false)}
                >
                  Settings
                </Link>
              </>
            )}
            <Link
              to="/getting-started"
              className="block text-text-secondary hover:text-white transition-colors"
              onClick={() => setMobileOpen(false)}
            >
              Getting Started
            </Link>
            <Link
              to="/pricing"
              className="block text-text-secondary hover:text-white transition-colors"
              onClick={() => setMobileOpen(false)}
            >
              Pricing
            </Link>
            <hr className="border-midnight-border" />
            {isLoggedIn ? (
              <Link
                to="/studio"
                className="block text-center px-4 py-2 bg-accent hover:bg-accent-dark text-white rounded-lg transition-colors"
                onClick={() => setMobileOpen(false)}
              >
                My Studio
              </Link>
            ) : (
              <>
                <Link
                  to="/login"
                  className="block text-text-secondary hover:text-white transition-colors"
                  onClick={() => setMobileOpen(false)}
                >
                  Login
                </Link>
                <Link
                  to="/signup"
                  className="block text-center px-4 py-2 bg-accent hover:bg-accent-dark text-white rounded-lg transition-colors"
                  onClick={() => setMobileOpen(false)}
                >
                  Sign Up
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}
